import React from 'react';
import Icon from '../../../../common/icons/Icon';
import formatClassDateRange from '../formatClassDateRange';

export default ({ school, classEntity, onClose }) => (
  <div className="gs-page__modal__body">
    <div className="icon--with-badge">
      <Icon icon="CheckmarkCircleOutline" className="icon--badge" />
      <Icon icon="Money" />
    </div>
    <p>
      Thank you for your purchase. We look forward to your visit{' '}
      {formatClassDateRange(classEntity.start_date, school.days)}. We will email you more information soon.
    </p>
    <button type="button" className="button button--theme--outline" onClick={onClose}>
      Close
    </button>
  </div>
);



// WEBPACK FOOTER //
// ./src/subscription/coaching/golf-schools/class-registration/ClassRegistrationSuccess.js